import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { modalFadeTrigger } from '../../../core/animations';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-enable-mfa-modal',
  templateUrl: './enable-mfa-modal.component.html',
  styleUrls: ['./enable-mfa-modal.component.scss'],
  animations: [modalFadeTrigger]
})
export class EnableMfaModalComponent implements OnInit {
  @HostBinding('@routeFadeState')
  @HostBinding('class.modal-info') true;
  public pending = false;
  public formErrors: any;
  @Input() text;
  @Input() deleteFunc: Function;
  private _txt = {
    header: 'DELETE',
    body: 'DELETE',
    submit: 'DELETE'
  };
  public txt;
  public qrCodeUrl;
  public token;

  constructor(public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.txt = Object.assign({}, this._txt, this.text);
    this.authService.enableMfa().subscribe((response: { qrCodeUrl: string }) => {
      console.log(response);
      this.qrCodeUrl = response.qrCodeUrl;
    });
  }

  onApplyClick() {
    console.log(`Token ${this.token}`);
    this.pending = true;
    this.authService.verifyMfa(this.token).subscribe(() => {
      this.toastr.info(`Pomyślnie ustawiono uwierzytelnianie wieloskładownikowe`);
      this.activeModal.close(true);
    }, (err) => {
      console.log(err);
      this.pending = false;
      this.formErrors = { name: 'WRONG_TOKEN'};
    });
    // this.formErrors = null;
    // if (this.deleteFunc) {
    //   this.pending = true;
    //   this.deleteFunc().subscribe(() => {
    //       this.activeModal.close(true);
    //     },
    //     (err) => {
    //       this.pending = false;
    //       this.formErrors = err;
    //     });
    // }
  }
}
